module.exports = __webpack_public_path__ + "img/home-logo.7c2bfb48.png";